module.exports = __webpack_public_path__ + "static/media/menorah.d8a20ae1.svg";